import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { BlueRoundedButtonWithIcon } from '../../common/components/BlueRoundedButton';
import {
  ModalTextContainer,
  WideModal,
} from '../../common/components/WideModal';

interface PaymentConfirmModalProps {
  open: boolean;
  onClose: () => void;
}
export const PaymentConfirmModal = ({
  open,
  onClose,
}: PaymentConfirmModalProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.cd.payment.modal',
  });

  return (
    <WideModal open={open} onClose={onClose} width="1080px">
      <ModalTextContainer>
        <Trans
          t={t}
          i18nKey="confirmMessage"
          components={[<br />, <strong />]}
        />
      </ModalTextContainer>
      <BlueRoundedButtonWithIcon
        marginTop="22px"
        onClick={() => {
          navigate('/requested-images');
          onClose();
        }}>
        {t('confirmButton')}
      </BlueRoundedButtonWithIcon>
    </WideModal>
  );
};
